const WORKER_URL = import.meta.env.VITE_WORKER_URL ?? "http://localhost:8787";

async function request(path, { signal } = {}) {
	const resp = await fetch(`${WORKER_URL}${path}`, { signal });
	if (!resp.ok) {
		let message = `Request failed: ${resp.status}`;
		try {
			const body = await resp.json();
			if (body?.error) message = body.error;
		} catch {
			// non-JSON body, keep default message
		}
		const err = new Error(message);
		err.status = resp.status;
		throw err;
	}
	return resp.json();
}

export function searchTv(query, { limit = 20, signal } = {}) {
	const params = new URLSearchParams({ q: query, limit: String(limit) });
	return request(`/tv/search?${params}`, { signal });
}

export function getTvShow(tvmazeId, { signal } = {}) {
	return request(`/tv/${tvmazeId}`, { signal });
}

// The full season/episode catalog in one call: { tvmaze_id, seasons, episodes }.
export function getTvEpisodes(tvmazeId, { signal } = {}) {
	return request(`/tv/${tvmazeId}/episodes`, { signal });
}

// A show by its IMDb id (imports) → the same shape as getTvShow; 404 if TVmaze
// doesn't know it.
export function lookupTvByImdb(imdbId, { signal } = {}) {
	return request(`/tv/lookup?imdb=${encodeURIComponent(imdbId)}`, { signal });
}
